var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.26 9.678H9.678a3.316 3.316 0 0 0-3.315 3.315v7.955a3.316 3.316 0 0 0 3.315 3.315h14.584a3.316 3.316 0 0 0 3.314-3.315v-7.955a3.316 3.316 0 0 0-3.314-3.315Zm-9.61 10.274v-5.965l5.965 2.977-5.966 2.99v-.002Zm2.32 13.987C7.598 33.939 0 26.342 0 16.969 0 7.598 7.598 0 16.97 0c9.37 0 16.969 7.597 16.969 16.97 0 9.372-7.598 16.969-16.97 16.969Z",
    fill: "#2C112D"
  })));
};
export default SvgYoutube;